import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-usf-expandable-panel',
  templateUrl: './usf-expandable-panel.component.html',
  styleUrls: ['./usf-expandable-panel.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsfExpandablePanelComponent implements OnInit {
  @Input() title = '';
  @Input() collapseContent = false;
  @Input() showArrow = true;
  @Input() displayHeader = true;

  // need to replace fixed component and addBottomMore with the styleObject
  @Input() fixedContent = false;
  @Input() addBottomBorder = false;
  @Input() stylesObject = {};

  @Input()
  set noBorders(value) {
    this.hideBorders = typeof value !== 'undefined' && value !== false;
  }

  @Output() collapsedVal: EventEmitter<boolean> = new EventEmitter();

  hideBorders = false;
  arrowDirection = false;

  constructor() {}

  ngOnInit() {
    this.arrowDirection = !this.collapseContent;
  }

  togglePanel(val: boolean) {
    this.arrowDirection = val;
    this.collapsedVal.emit(val);
  }
}
